import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { MasterRateApiItemInterface } from 'features/Enterprise/Payroll/types'

export type BasePayUpdateType = {
  current: number
  future: number
  effectiveDate: string
}

export type MasterRateItemType = {
  id: number
  role: string
  basePay: string
  ho: string
  ho2: string
  ot2_4: string
  ot_gt4: string
  halfDay: string
  onleave: string
  volunteer: string
  effectiveDate: string
  rateType: string
  basePayUpdate?: BasePayUpdateType
}

export interface MasterRateInitialStateInterface {
  isLoading: boolean
  masterRateList: MasterRateApiItemInterface[]
  query: {
    sort: string
    direction: string
    pageSize: number
    pageIndex: number
    numberOfElements: number
    prevCursor: string
    nextCursor: string
  }
}

const initialState: MasterRateInitialStateInterface = {
  isLoading: false,
  masterRateList: [],
  query: {
    direction: 'role',
    pageIndex: 1,
    pageSize: 20,
    sort: 'asc',
    numberOfElements: 0,
    prevCursor: '',
    nextCursor: '',
  },
}

export const sliceName = 'masterRate'

const appSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    reset: () => initialState,
    setLoading: (state, action: PayloadAction<MasterRateInitialStateInterface['isLoading']>) => {
      state.isLoading = action.payload
    },
    setMasterRateList: (
      state,
      action: PayloadAction<MasterRateInitialStateInterface['masterRateList']>,
    ) => {
      state.masterRateList = action.payload
    },
    setQuery: (state, action: PayloadAction<MasterRateInitialStateInterface['query']>) => {
      state.query = action.payload
    },
  },
})

export const { reset, setLoading, setMasterRateList, setQuery } = appSlice.actions

export default appSlice.reducer
